export default __webpack_public_path__ + "static/g2-645e2afb6ae4dd599f54256212bd8205.svg";